import React, { useEffect, useRef } from 'react';
import BaseModalForm from "components/BaseModalForm";
import Vocabulary from "components/Vocabulary";
import { forwardRef } from "react";
import { FieldTypes } from "utils/formUtils";
import _ from 'lodash';
import ExceptionAPI from 'restAPI/ExceptionAPI';
import message from 'components/CustomMessage';

export const CopyExceptionModal = forwardRef(({ afterClose, currentName, id }, ref) => {
	const validateAPIRef = useRef();

	useEffect(() => {
		return _.isFunction(validateAPIRef.current) && validateAPIRef.current();
	}, []);

	const fields = [
		{
			name: 'newExceptionName',
			label: 'Name',
			type: FieldTypes.ANTD_DEFAULT_INPUT,
			required: true,
		}
	];

	const onSubmit = (values) => {
		return ExceptionAPI.copyException(id, values.newExceptionName).promise.then(() => {
			message.success("Copy initiated, please check after some time.");
		});
	}

	return (
		<BaseModalForm
			initialValues={{
				newExceptionName: currentName + " (Copy)"
			}}
			onOk={onSubmit}
			ref={ref}
			title={<>Copy <Vocabulary name="exception" /></>}
			fields={fields}
			afterClose={afterClose}
		/>
	)
})